// Where the mesh coordinator lives. Set at build time via VITE_MESH_URL (e.g.
// "wss://mesh.litesolve.com"); falls back to the local docker-compose coordinator in dev.
// When neither is meaningful the mesh UI is hidden entirely — the playground stays a working
// static site with no backend, exactly as before.

const RAW = import.meta.env.VITE_MESH_URL as string | undefined;

// Dev default: the coordinator from `docker compose up` in coordinator/. In a production
// build VITE_MESH_URL should be set; if it isn't, meshEnabled() is false and the toggle /
// Contribute entry points don't render.
const DEV_DEFAULT = "ws://localhost:8787";

export const MESH_URL: string | null =
  RAW && RAW.trim() ? RAW.trim() : import.meta.env.DEV ? DEV_DEFAULT : null;

export function meshEnabled(): boolean {
  return MESH_URL !== null;
}
